<template>
  <!--eslint-disable-->
  <div id="fildAddrPop" class="popup-wrap">
    <div class="dimmed"/>
    <div class="popup-layer">
      <div class="popup-header">
        <h1>주소찾기</h1>
        <button type="button" class="btn-close" @click="closePopup">
          <i class="ico-close"></i>
        </button>
      </div>
      <div class="popup-content find_post">
        <div class="find_post_inp">
          <div class="find_post_form_wrap">
            <div class="select_box">
              <select title="선택하세요" v-model="search.location">
                <option value=0>선택</option>
                <option v-for="(data, index) in list" :key="index" :value="data.title">{{data.title}}</option>
              </select>
            </div>
            <div class="inp_wrap inp_wrap_search">
                <input type="text" placeholder="도로명, 지번, 건물명을 입력하세요." v-model="search.address" @keyup.enter="handleState"/>
                <button type="button" class="btn btn-search-addr" @click="handleState"><span class="blind">검색</span></button>
            </div>
          </div>
        </div>
        <div class="find_post_dataList" v-if="addressList.length > 0">
          <ul>
              <li class="post_data"
              v-for="(item, index) in addressList"
              :key="index"
              @click.stop="setAddress(item)"
              >
                  <div class="post_data_left">
                      <strong>{{ item.zipno }}</strong>
                      <span>{{ item.jibno }}</span>
                  </div>
                  <div class="post_data_field">
                      <span>도로명</span>
                      <span>{{ item.road }}</span>
                  </div>
                  <div class="post_data_field">
                      <span>지번</span>
                      <span>{{ item.jibun }}</span>
                  </div>
              </li>
          </ul>
          <!-- <infinite-loading spinner="default" @infinite="searchAddress">
            <div slot="no-more"/>
            <div slot="no-results"/>
          </infinite-loading> -->
        </div>
        <div class="find_post_dataList no_data" v-else>
           <p>검색결과가 존재하지 않습니다.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'

export default {
  name: 'SearchAddrAlert',
  components: {
    InfiniteLoading
  },
  data () {
    return {
      // InfiniteLoading
      limit: 0,
      list: [
        {idx: 1, title: '서울특별시'},
        {idx: 2, title: '부산광역시'},
        {idx: 3, title: '대구광역시'},
        {idx: 4, title: '인천광역시'},
        {idx: 5, title: '광주광역시'},
        {idx: 6, title: '대전광역시'},
        {idx: 7, title: '울산광역시'},
        {idx: 8, title: '세종특별자치시'},
        {idx: 9, title: '경기도'},
        {idx: 10, title: '강원도'},
        {idx: 11, title: '충청북도'},
        {idx: 12, title: '충청남도'},
        {idx: 13, title: '전라북도'},
        {idx: 14, title: '전라남도'},
        {idx: 15, title: '경상북도'},
        {idx: 16, title: '경상남도'},
        {idx: 17, title: '제주특별자치도'}
      ],
      search: {
        location: 0,
        address: ''
      },
      addressList: [],
      searchList: [],
      currentPage: 1,
      countPerPage: 30
    }
  },
  computed: {
    isValidParam () {
      return true
    }
  },
  /* vue lifecycle */
  created () {
  },
  beforeMount () {
  },
  mounted () {
  },
  /* vue function */
  methods: {
    closePopup () {
      this.initAdd()
      this.$emit('close', {})
    },
    alert: async function () {
      let alertParams = { title: '주소찾기', contents: '주소를 입력하세요.', okBtnNm:'확인' }
      await this.$popup.alert(this.$el, alertParams)
    },
    handleState (event) {
      this.initAdd()
      if (this.search.location === 0 || this.search.location === '선택' || this.search.address === '') {
        this.alert()
        return
      }
      // 1. 엔터를 입력하면 텍스트 필드의 커서를 없애줍니다.
      if (event) event.target.blur()
      this.searchAddress()
    },
    /*
    목적: (GET) 사용자 기본 정보 조회, 요청 url: 'mrm/v1/permit/mobile/zipcode'
    요청 데이터: 주소 검색 리스트
    작성일: 2019.03.10
    작성자: 김정윤
    수정 계획: 1) 코드 번잡해서 간소화
    */
    searchAddress (state) {
      console.log('state', state)
      let word = `${this.search.location} ${this.search.address}`
      console.log('word', word)
      let params = {
        currentPage: this.currentPage,
        countPerPage: this.countPerPage,
        keyword: word
      }

      this.$http.mmp.zipcode(this, params).then( (result) => {
        const data = result.data
        console.log('SEARCH', data)
        if (data && data !== undefined) {
          let juso = data.data.results.juso
          console.log('juso.length', juso.length)

          this.searchList = []
          if ( data && typeof data !== 'undefined' && typeof juso !== 'undefined' && juso.length > 0 ) {
            this.currentPage += 1

            for (let item of juso) {
              this.searchList.push({
                zipno: item.zipNo,
                jibno: this.makeJibno(item),
                road: item.roadAddr,
                jibun: item.jibunAddr
              })
            }
            this.addressList = this.addressList.concat(this.searchList)
            if (state) {
              state.loaded()

              if (typeof juso === 'undefined' || juso.length === 0) {
                console.log('no data')
                // this.initAdd()
                state.complete()
              }
            }
          } else {
            if (state) state.complete()
            console.log('else')
          }
        }
      }).catch((error) => {
        console.log(error.message)
        // this.$toast.show(this.$t('MCOM9999'))
      })
    },
    /*
    목적: 지번 우편 주소를 만든다.
    작성일: 2019.03.10
    작성자: 김정윤
    */
    makeJibno ( item ) {
      let jibno = ''
      if (item.lnbrSlno !== '0') jibno = `(${item.lnbrMnnm}-${item.lnbrSlno})`
      else jibno = `(${item.lnbrMnnm})`
      return jibno
    },
    initAdd () {
      this.addressList = []
      this.currentPage = 1
      this.countPerPage = 30
    },
    // 주소 클릭
    setAddress (item) {
      this.$emit('close', {data: item})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/SearchAddrAlert.vue